import request from 'shared/lib/request';
import { API } from 'shared/constants';
import qs from 'qs';

const create = (content) => request(
  {
    url: API.NOTA_PRATICA,
    method: 'POST',
    data: content,
  });

const put = (content) => request(
  {
    url: `${API.NOTA_PRATICA}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const get = (id) => request(
  {
    url: `${API.NOTA_PRATICA}/${id}`,
    method: 'GET',
  });

const getByPratica = (praticaId) => request(
  {
    url: API.NOTA_PRATICA,
    method: 'GET',
    params: {
      filter: [{
        type: 'eq',
        field: 'pratica',
        value: praticaId || null,
      }],
      'order-by': [{
        type: 'field',
        field: 'updatedAt',
        direction: 'desc',
      }],
    },
    paramsSerializer: (params) => qs.stringify(params),
  }
);

const del = (id) => request(
  {
    url: `${API.NOTA_PRATICA}/${id}`,
    method: 'DELETE',
  });

const reply = (parent, pratica, descrizione) => request(
  {
    url: API.NOTA_PRATICA,
    method: 'POST',
    data: {
      parent,
      pratica,
      descrizione,
    },
  }
);

const NoteService = {
  create,
  put,
  del,
  get,
  getByPratica,
  reply,
};

export default NoteService;



// WEBPACK FOOTER //
// ./app/shared/services/api/notepratica/index.js